// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/remote-config";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

export const auth = app.auth();
export const firebaseAuth = firebase.auth;
export const db = firebase.firestore();
export const storage = getStorage(app);

// Initialize Remote Config and get a reference to the service
export const remoteConfig = firebase.remoteConfig();
// Default fetch throttle is 12 hours, which keeps a stale empty template after
// a fresh publish. Soften that for local QA; keep a 1h floor in production.
remoteConfig.settings = {
  minimumFetchIntervalMillis:
    process.env.NODE_ENV === "development" ? 0 : 60 * 60 * 1000,
};

// Analytics only when a measurementId is configured (optional for temp).
export const analytics = firebaseConfig.measurementId
  ? getAnalytics(app)
  : null;

export default app;
